import { render } from "./BigLoader.vue?vue&type=template&id=dce65ac0&scoped=true"
import script from "./BigLoader.vue?vue&type=script&lang=js"
export * from "./BigLoader.vue?vue&type=script&lang=js"

import "./BigLoader.vue?vue&type=style&index=0&id=dce65ac0&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce65ac0"]])

export default __exports__